import { useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { Building2, CreditCard, FilePlus2, Home, KeyRound, Landmark, ListChecks, LogOut, Menu, ShieldCheck, WalletCards } from 'lucide-react'
import { useAuth } from '../lib/AuthContext'
import { Modal } from './Modal'
import { supabase } from '../lib/supabase'

const nav = [
  { to: '/', label: 'Página inicial', icon: Home, admin: false },
  { to: '/cadastro-conta', label: 'Cadastro de conta', icon: FilePlus2, admin: true },
  { to: '/contas-a-pagar', label: 'Contas a pagar', icon: ListChecks, admin: false },
  { to: '/cadastro-cartao-roly', label: 'Cadastro Cartão Roly', icon: CreditCard, admin: true },
  { to: '/cartao-roly', label: 'Cartão Roly', icon: WalletCards, admin: false },
  { to: '/cronograma-clientes', label: 'Cronograma Metropolitan', icon: Building2, admin: false },
  { to: '/gestao-cadastros-metropolitan', label: 'Gestão Metropolitan', icon: Building2, admin: true },
  { to: '/integracoes-bancarias', label: 'Integrações Metropolitan', icon: Landmark, admin: true },
  { to: '/gestao-emails', label: 'Gestão de e-mails', icon: ShieldCheck, admin: true },
]

export function Layout() {
  const { profile, signOut } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)
  const [menuCollapsed, setMenuCollapsed] = useState(false)
  const [passwordOpen, setPasswordOpen] = useState(false)
  const isAdmin = profile?.role === 'admin'

  function toggleMenu() {
    if (window.matchMedia('(max-width: 1050px)').matches) setMenuOpen(value => !value)
    else setMenuCollapsed(value => !value)
  }

  return (
    <div className="app-shell">
      {menuOpen && <button className="sidebar-overlay" aria-label="Fechar menu" onClick={() => setMenuOpen(false)} />}
      <aside className={`sidebar ${menuOpen ? 'open' : ''} ${menuCollapsed ? 'collapsed' : ''}`}>
        <div className="brand"><strong>Financeiro</strong></div>
        <div className="user-card"><span>{profile?.name}</span><small>{isAdmin ? 'Administrador' : 'Usuário Padrão'}</small></div>
        <nav>
          {nav.filter(item => !item.admin || isAdmin).map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>
              <Icon size={19} /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-actions">
          <button onClick={() => setPasswordOpen(true)}><KeyRound size={18} />Trocar senha</button>
          <button onClick={signOut}><LogOut size={18} />Sair</button>
        </div>
      </aside>
      <div className={`main-column ${menuCollapsed ? 'menu-collapsed' : ''}`}>
        <main><div className="page-menu-area"><button className="page-menu-toggle icon-button" onClick={toggleMenu} aria-label="Alternar menu"><Menu /></button></div><Outlet /></main>
      </div>
      {passwordOpen && <ChangePassword onClose={() => setPasswordOpen(false)} />}
    </div>
  )
}

function ChangePassword({ onClose }: { onClose: () => void }) {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [message, setMessage] = useState('')
  const [saving, setSaving] = useState(false)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    if (next.length < 8) return setMessage('A nova senha deve ter pelo menos 8 caracteres.')
    if (next !== confirm) return setMessage('A confirmação da nova senha não confere.')
    setSaving(true)
    const { data: userData } = await supabase.auth.getUser()
    const email = userData.user?.email
    if (!email) { setMessage('Sessão inválida.'); setSaving(false); return }
    const { error: checkError } = await supabase.auth.signInWithPassword({ email, password: current })
    if (checkError) { setMessage('Senha atual incorreta.'); setSaving(false); return }
    const { error } = await supabase.auth.updateUser({ password: next })
    setSaving(false)
    if (error) return setMessage(error.message)
    setMessage('Senha alterada com sucesso.')
    window.setTimeout(onClose, 900)
  }

  return <Modal title="Trocar senha" onClose={onClose} width="480px"><form className="stack" onSubmit={submit}>
    <p className="muted">Informe sua senha atual e escolha uma nova senha.</p>
    <label>Senha atual<input type="password" value={current} onChange={e => setCurrent(e.target.value)} required /></label>
    <label>Nova senha<input type="password" value={next} onChange={e => setNext(e.target.value)} required minLength={8} /></label>
    <label>Nova senha (confirmação)<input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required /></label>
    {message && <p className="form-message">{message}</p>}
    <div className="form-actions"><button type="button" className="secondary" onClick={onClose}>Cancelar</button><button disabled={saving}>{saving ? 'Salvando…' : 'Salvar nova senha'}</button></div>
  </form></Modal>
}
